import { useMemo } from 'react';

import { loadStripe, StripeElementLocale } from '@stripe/stripe-js';

import { useTranslation } from '../../../../i18n';
import { useStripeConfig } from '../../../../config/hooks';

function convertStripeLocale(locale: string | StripeElementLocale): StripeElementLocale {
  const supported: Partial<StripeElementLocale>[] = ['en', 'ru', 'el'];

  return supported.includes(locale as StripeElementLocale) ? (locale as StripeElementLocale) : 'en';
}

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
function createStripePromise(publishable: string, locale: string) {
  return loadStripe(publishable, {
    apiVersion: '2020-08-27',
    locale: convertStripeLocale(locale),
  });
}

export function useStripePromise() {
  const [, i18n] = useTranslation();
  const stripeConfig = useStripeConfig();

  return useMemo(() => createStripePromise(stripeConfig, i18n.language), [stripeConfig, i18n.language]);
}
